import { DataLayerWhere } from '@/modules/cart/services/data-layer-events/add-to-cart';
import { sendGTMEvent } from '@/modules/common/services/sendGTMEvent';
import { DataLayerFeature } from '@/modules/product/services/data-layer-events/add-to-wishlist';
import { DATA_LAYER_EVENTS } from '@/modules/product/services/data-layer-events/events';

type selectContentDataLayerEventProps = {
  contentId?: string;
  contentType: string;
  feature?: DataLayerFeature;
  name: string;
  room?: string;
  where?: DataLayerWhere;
};

export function selectContentDataLayerEvent({
  contentId,
  contentType,
  feature,
  name,
  room,
  where,
}: selectContentDataLayerEventProps) {
  sendGTMEvent({ eventData: null });

  sendGTMEvent({
    event: DATA_LAYER_EVENTS.select_content,
    eventData: {
      content_id: contentId,
      content_type: contentType,
      name,
      feature,
      where,
      room,
    },
  });
}
